import { Card, CardContent } from "../ui/card";
import { BookMarked } from "lucide-react";

export default function HandbookCard() {
  return (
    <Card className="h-40 rounded-xl border-border shadow-sm hover:cursor-pointer">
      <CardContent className="h-full pt-4 p-1">
        <a href="/handbooks/company.html" target="_blank" rel="noreferrer" data-testid="dashboard-handbook">
          <div className="my-auto flex h-full flex-col justify-center gap-3 pt-4 text-center">
            <div className="mx-auto">
              <BookMarked size={24} className="text-neutral-500" />
            </div>
            <div className="mx-auto flex w-full gap-2 align-bottom px-2">
              <div className="mt-auto text-base font-semibold text-card-foreground w-full">Handbook</div>
            </div>
          </div>
        </a>
      </CardContent>
    </Card>
  );
}
